import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { GearDocumentMetadata } from '../../Model/GearDocumentMetadata';
import { GetDocumentVersionMetadataRequest } from '../../Model/requests/GetDocumentVersionMetadataRequest';
import { useContext } from 'react';
import ServicesContext from '../../global/services/ServicesContext';
import { versionsQueryKeys } from './queryKeyFactory';

export function useGetDocumentVersionMetadata(
  dto: GetDocumentVersionMetadataRequest,
  options?: Partial<UseQueryOptions<{ metadata: GearDocumentMetadata }, unknown>>
): UseQueryResult<{ metadata: GearDocumentMetadata }, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getDocumentVersionMetadata = () => {
    if (servicesCtx?.versionsService) {
      return servicesCtx.versionsService.getVersionMetadata(dto);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: versionsQueryKeys.getVersionMetadata(dto),
    queryFn: getDocumentVersionMetadata,
    retry: 0,
    staleTime: 180000,
    gcTime: 180000,
    enabled: dto.versionId.length > 0,
    ...options
  });
}
